import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { espaciosService } from '../services/api';
import { useAuthStore } from '../store/auth';
import { useEspacioStore } from '../store/espacio';

// Selector "Cambiar de espacio" / "Ver como". Solo aparece si el usuario tiene
// acceso a algún espacio ajeno o si ya está viendo uno. El servidor valida cada
// petición contra la membresía; esto solo elige qué X-Espacio se manda.
export default function EspacioBanner() {
  const navigate = useNavigate();
  const userId = useAuthStore(s => s.user?.id);
  const { espacio, setEspacio } = useEspacioStore();
  const [activos, setActivos] = useState([]);

  useEffect(() => {
    let vivo = true;
    espaciosService.listar()
      .then(r => {
        if (!vivo) return;
        const lista = (r.data?.espacios || []).filter(x => x.estado === 'activo');
        setActivos(lista);
        // Un espacio que ya no existe (revocado, otra cuenta) se suelta solo
        if (espacio && !lista.some(x => x.propietario_id === espacio.id && x.rol === espacio.rol)) setEspacio(null);
      })
      .catch(() => {});
    return () => { vivo = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!espacio && activos.length === 0) return null;

  const cambiar = (e) => {
    const v = e.target.value;
    if (v === '') { setEspacio(null); navigate('/dashboard'); return; }
    const sel = activos.find(x => String(x.id) === v);
    if (!sel) return;
    setEspacio({ id: sel.propietario_id, rol: sel.rol, nombre: sel.propietario });
    navigate(sel.rol === 'contador' ? '/espacio/lectura' : '/presupuestos');
  };

  return (
    <div className={`px-4 py-2 text-sm flex flex-wrap items-center gap-3 ${espacio ? 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100' : 'bg-slate-100 dark:bg-slate-800'}`}>
      <label htmlFor="espacio-sel" className="font-medium">
        {espacio ? `Viendo el espacio de ${espacio.nombre} (${espacio.rol === 'contador' ? 'solo lectura' : 'hogar'})` : 'Cambiar de espacio'}
      </label>
      <select
        id="espacio-sel"
        value={espacio ? (activos.find(x => x.propietario_id === espacio.id && x.rol === espacio.rol)?.id ?? '') : ''}
        onChange={cambiar}
        className="px-2 py-1 rounded border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-white"
      >
        <option value="">Mi espacio</option>
        {activos.map(a => (
          <option key={a.id} value={a.id}>{a.propietario} ({a.rol})</option>
        ))}
      </select>
      {espacio && (
        <span className="text-xs opacity-80">
          {espacio.rol === 'contador'
            ? 'Solo se muestran transacciones, CFDI y exportaciones de esta persona.'
            : 'Los presupuestos, sobres y gastos compartidos que edites son de esta persona.'}
        </span>
      )}
    </div>
  );
}
